import { CustomTabPanel } from "@/erp/sale";
import {
  a11yProps,
  EstadoPreventaEnum,
  gridSize,
  gridSizeMdLg12,
  gridSizeMdLg6,
  ModulosEnumChoice,
  ROUTER_PATHS,
  sizeTab,
  texto,
} from "@/shared";
import { useFetchPutPreventaPymes } from "@/shared/actions/erp/preventa_pymes/preventa_pymes.action";
import {
  CustomTextFieldNoForm,
  PDFReader,
  SingleTableBoxScene,
  TabTextLabel,
  useModalMotivoRechazo,
} from "@/shared/components/ui";
import ModalMotivoRechazo from "@/shared/components/ui/ModalMotivoRechazo/ModalMotivoRechazo";
import TipoVentaCanjeEvento from "@/shared/components/ui/TipoVentaCanjeEvento/TipoVentaCanjeEvento";
import { TipoSolicitudesEnum } from "@/shared/interfaces";
import { IPreventaPymes } from "@/shared/interfaces/erp/ventas_pymes/preventa_pymes.interface";
import { usePlanStore } from "@/store/erp/system-settings/plan.store";
import { useUiStore } from "@/store/ui";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { Alert, Box, Grid, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

interface SaveSolicitudClientePymesProps {
  dataPreventa: IPreventaPymes;
}
export default function SaveSolicitudClientePymes({
  dataPreventa,
}: SaveSolicitudClientePymesProps) {
  const [valueTab, setValueTab] = useState(0);

  const routerBack = ROUTER_PATHS.clientes.clientesPymesNav;
  const navigate = useNavigate();

  const setConfirmDialog = useUiStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiStore((s) => s.setConfirmDialogIsOpen);

  const { mutateAsync: mutateAsyncPutPreventa } = useFetchPutPreventaPymes({
    returnUrl: routerBack,
    navigate,
  });

  const plans = usePlanStore((s) => s.plans);

  const useHookModalMotivoRechazo = useModalMotivoRechazo({
    modulo: ModulosEnumChoice.PREVENTA_PYMES,
    gestionVenta: true,
    returnUrl: ROUTER_PATHS.clientes.clientesPymesNav,
  });

  return (
    <>
      <SingleTableBoxScene
        title="Revisión Contrato PYMES"
        enableBackBtn={true}
        backPageUrl={routerBack}
        //* aprobar
        enableCreateOrEditBtn={true}
        textCreateOrEditBtn="Aprobar"
        iconCreateOrEdit={<CheckCircleIcon />}
        fnCreateOrEdit={() => {
          setConfirmDialog({
            isOpen: true,
            title: "Aceptar contrato",
            subtitle:
              "¿Estás seguro de aceptar el contrato físico? Una vez confirmado, este cambio no se puede revertir.",
            onConfirm: async () => {
              setConfirmDialogIsOpen(false);
              await mutateAsyncPutPreventa({
                id: dataPreventa.id_preventa_pymes!,
                data: {
                  estado_preventa: EstadoPreventaEnum.EN_ESPERA,
                  pre_requiere_contrato_fisico: false,
                  requiere_contrato_fisico: true,
                  estado_aceptacion: true,
                },
              });
            },
            onClose: () => {
              setConfirmDialogIsOpen(false);
            },
          });
        }}
        //* rechazar
        enableAccionBtn={true}
        labelTextActionBtn="Enviar a Gestion Venta"
        fnAccionBtn={() => {
          useHookModalMotivoRechazo.setDialogContentText(
            `Para enviar a Gestión Ventas el agendamiento es necesario seleccionar el motivo de rechazo. ¿Desea continuar?`,
          );
          useHookModalMotivoRechazo.setModalCancelar(true);
          useHookModalMotivoRechazo.reset({
            id: dataPreventa.id_preventa_pymes,
            observaciones: dataPreventa.observaciones,
          });

          //alert('ENVIAR A GESTION VENTA')
        }}
        py={3}
      >
        <Box
          sx={{
            display: "flex",
            textAlign: "center",
            justifyContent: "center",
            //border: '1px solid #ccc'
          }}
        >
          <Grid container spacing={3} width={"80%"}>
            <Grid item xs={12}>
              <Box
                sx={{
                  bgcolor: "background.paper",
                  maxWidth: sizeTab,
                  paddingBottom: 2,
                }}
              >
                <Tabs
                  value={valueTab}
                  onChange={(
                    _event: React.SyntheticEvent,
                    newValue: number,
                  ) => {
                    setValueTab(newValue);
                  }}
                  variant="scrollable"
                  scrollButtons="auto"
                  allowScrollButtonsMobile
                  aria-label="scrollable force tabs preventa"
                >
                  <Tab label={"Contrato"} {...a11yProps(0)} />
                  <Tab label={"Documentos habilitantes"} {...a11yProps(1)} />
                </Tabs>
              </Box>

              <CustomTabPanel value={valueTab} index={0}>
                <Grid item xs={12}>
                  {dataPreventa.contrato_data?.url_contrato ? (
                    <PDFReader
                      fileUrl={
                        `${dataPreventa.contrato_data?.url_contrato}?v=${new Date().getTime()}` ||
                        ""
                      }
                    />
                  ) : (
                    <Alert variant="outlined" severity="info">
                      No hay documento
                    </Alert>
                  )}
                </Grid>
              </CustomTabPanel>

              <CustomTabPanel value={valueTab} index={1}>
                <Grid item xs={12}>
                  {dataPreventa.url_documentos_habilitantes ? (
                    <PDFReader
                      fileUrl={
                        `${dataPreventa.url_documentos_habilitantes}?v=${new Date().getTime()}` ||
                        ""
                      }
                    />
                  ) : (
                    <Alert variant="outlined" severity="info">
                      No hay documento
                    </Alert>
                  )}
                </Grid>
              </CustomTabPanel>
            </Grid>

            <Grid item xs={12}>
              <TabTextLabel
                text={texto.informacion_personal}
                mt={0}
                pb={2}
                pl={0}
                pt={2}
              />
            </Grid>

            <Grid item xs={12}>
              <TipoVentaCanjeEvento
                tipo_venta={TipoSolicitudesEnum.PYMES}
                prospecto_data={dataPreventa.prospecto_pymes_data as any}
              />
            </Grid>

            <CustomTextFieldNoForm
              disabled={true}
              label={texto.tipo_documento}
              defaultValue={
                dataPreventa.prospecto_pymes_data?.tipo_identificacion ?? ""
              }
              value={
                dataPreventa.prospecto_pymes_data?.tipo_identificacion ?? ""
              }
              size={gridSizeMdLg6}
            />

            <CustomTextFieldNoForm
              disabled={true}
              label={texto.identificacion}
              defaultValue={
                dataPreventa.prospecto_pymes_data?.identificacion ?? ""
              }
              value={dataPreventa.prospecto_pymes_data?.identificacion ?? ""}
              size={gridSizeMdLg6}
            />

            <CustomTextFieldNoForm
              disabled={true}
              label={"Razon Social"}
              defaultValue={
                dataPreventa.prospecto_pymes_data?.razon_social ?? ""
              }
              value={dataPreventa.prospecto_pymes_data?.razon_social ?? ""}
              size={gridSizeMdLg6}
            />

            <Grid item xs={12} display={"flex"}>
              <TabTextLabel
                text={"Representante Legal"}
                mt={0}
                pb={2}
                pl={0}
                pt={0}
              />
            </Grid>

            <CustomTextFieldNoForm
              disabled={true}
              label={"Razon Social"}
              defaultValue={
                dataPreventa?.representante_legal_razon_social ?? ""
              }
              value={dataPreventa.representante_legal_razon_social ?? ""}
              size={gridSize}
            />

            <CustomTextFieldNoForm
              disabled={true}
              label={"Tipo Identificacion"}
              defaultValue={
                dataPreventa?.representante_legal_tipo_identificacion ?? ""
              }
              value={dataPreventa.representante_legal_tipo_identificacion ?? ""}
              size={gridSizeMdLg6}
            />

            <CustomTextFieldNoForm
              disabled={true}
              label={"Identificacion"}
              defaultValue={
                dataPreventa?.representante_legal_identificacion ?? ""
              }
              value={dataPreventa.representante_legal_identificacion ?? ""}
              size={gridSizeMdLg6}
            />

            <Grid item xs={12} display={"flex"}>
              <TabTextLabel
                text={"Forma de Pago"}
                mt={0}
                pb={2}
                pl={0}
                pt={0}
              />
            </Grid>

            <CustomTextFieldNoForm
              disabled={true}
              label={"Forma Pago"}
              defaultValue={
                dataPreventa?.forma_pago_data?.alias ??
                dataPreventa?.forma_pago_v2_data?.nombre ??
                dataPreventa?.tipo_pago_v2 ??
                ""
              }
              value={
                dataPreventa?.forma_pago_data?.alias ??
                dataPreventa?.forma_pago_v2_data?.nombre ??
                dataPreventa?.tipo_pago_v2 ??
                ""
              }
              size={gridSizeMdLg6}
            />

            {dataPreventa.tipo_cuenta_bancaria && (
              <>
                <CustomTextFieldNoForm
                  disabled={true}
                  label={"Tipo Cuenta Bancaria"}
                  defaultValue={dataPreventa?.tipo_cuenta_bancaria ?? ""}
                  value={dataPreventa.tipo_cuenta_bancaria ?? ""}
                  size={gridSizeMdLg6}
                />

                <CustomTextFieldNoForm
                  disabled={true}
                  label={"Número Cuenta"}
                  defaultValue={dataPreventa?.numero_cuenta ?? ""}
                  value={dataPreventa.numero_cuenta ?? ""}
                  size={gridSizeMdLg6}
                />
              </>
            )}

            {dataPreventa.numero_tarjeta && (
              <>
                <CustomTextFieldNoForm
                  disabled={true}
                  label={"Entidad Financiera"}
                  defaultValue={dataPreventa?.entidad_financiera ?? ""}
                  value={dataPreventa.entidad_financiera ?? ""}
                  size={gridSizeMdLg6}
                />

                <CustomTextFieldNoForm
                  disabled={true}
                  label={"Número Tarjeta"}
                  defaultValue={dataPreventa?.numero_tarjeta ?? ""}
                  value={dataPreventa.numero_tarjeta ?? ""}
                  size={gridSizeMdLg6}
                />
              </>
            )}

            {dataPreventa.coordenadas.map((element, index) => {
              const planFind = plans.find((p) => p.codigo == element.plan);

              return (
                <>
                  <Grid item xs={12} display={"flex"}>
                    <TabTextLabel
                      text={`Punto de Enlace: ${element.nombre}`}
                      mt={0}
                      pb={2}
                      pl={0}
                      pt={0}
                    />
                  </Grid>

                  <CustomTextFieldNoForm
                    key={`coordenada-${index}`}
                    disabled={true}
                    label={"Coordenada"}
                    defaultValue={element.coordenada ?? ""}
                    value={element.coordenada ?? ""}
                    size={gridSizeMdLg12}
                  />

                  <CustomTextFieldNoForm
                    key={`coordenada-${index}`}
                    disabled={true}
                    label={"Dirección"}
                    defaultValue={element.direccion ?? ""}
                    value={element.direccion ?? ""}
                    size={gridSizeMdLg12}
                  />

                  <CustomTextFieldNoForm
                    key={`plan-${index}`}
                    disabled={true}
                    label={"Nombre Plan"}
                    defaultValue={planFind?.nombre ?? ""}
                    value={planFind?.nombre ?? ""}
                    size={gridSizeMdLg6}
                  />

                  <CustomTextFieldNoForm
                    key={`tipo_plan-${index}`}
                    disabled={true}
                    label={"Tipo Plan"}
                    defaultValue={planFind?.tipo_plan ?? ""}
                    value={planFind?.tipo_plan ?? ""}
                    size={gridSizeMdLg6}
                  />

                  <CustomTextFieldNoForm
                    key={`tipo_servicio-${index}`}
                    disabled={true}
                    label={"Tipo Servicio"}
                    defaultValue={planFind?.tipo_servicio ?? ""}
                    value={planFind?.tipo_servicio ?? ""}
                    size={gridSizeMdLg6}
                  />

                  <CustomTextFieldNoForm
                    key={`valor-${index}`}
                    disabled={true}
                    label={"Valor del Plan"}
                    defaultValue={planFind?.valor ?? ""}
                    value={planFind?.valor ?? ""}
                    size={gridSizeMdLg6}
                  />

                  <CustomTextFieldNoForm
                    key={`valor_instalacion-${index}`}
                    disabled={true}
                    label={"Valor Instalación"}
                    defaultValue={element.valor_instalacion ?? ""}
                    value={element.valor_instalacion ?? ""}
                    size={gridSizeMdLg6}
                  />

                  <CustomTextFieldNoForm
                    key={`valor_instalacion_total-${index}`}
                    disabled={true}
                    label={"Valor Instalación Total"}
                    defaultValue={element.valor_instalacion_total ?? ""}
                    value={element.valor_instalacion_total ?? ""}
                    size={gridSizeMdLg6}
                  />
                </>
              );
            })}
          </Grid>
        </Box>
      </SingleTableBoxScene>

      {/*Modal para cancelar*/}

      <ModalMotivoRechazo {...useHookModalMotivoRechazo} />
    </>
  );
}
